import { render, staticRenderFns } from "./BillConceptsTable.vue?vue&type=template&id=707accc4&scoped=true"
import script from "./BillConceptsTable.ts?vue&type=script&lang=ts&external"
export * from "./BillConceptsTable.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707accc4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2316091614/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('707accc4')) {
      api.createRecord('707accc4', component.options)
    } else {
      api.reload('707accc4', component.options)
    }
    module.hot.accept("./BillConceptsTable.vue?vue&type=template&id=707accc4&scoped=true", function () {
      api.rerender('707accc4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/Bills/components/details/BillConcepts/BillConceptsTable/BillConceptsTable.vue"
export default component.exports